import { render, staticRenderFns } from "./CTimeButtons2.vue?vue&type=template&id=47694670&scoped=true"
import script from "./CTimeButtons2.vue?vue&type=script&lang=js"
export * from "./CTimeButtons2.vue?vue&type=script&lang=js"
import style0 from "./CTimeButtons2.vue?vue&type=style&index=0&id=47694670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47694670",
  null
  
)

export default component.exports